import _ from '../../common/utility';

function indexFilter() {

	if ($('main').hasClass('filtered-content')) {

		var currPage = 1;
		var pageSize = 20;
		var totalPage;
		var numFound;		
		var currSpecialty = '';
		var currResult;
		
		function chkQuery(param) {
			var resRegEx = new RegExp("[?&]" + param + "=[^&#]+", "g");
			var query = window.location.href.match(resRegEx);
			if (query != null && $.trim(query[0].split('=')[1]) != '') {
				query = query[0].split('=')[1];
			}
			return query;
		}
		
		function renderResult(json) {
			currResult = json;
			$('.index-list').html('');
			$(json.data.response.docs).each(function() {
				$('.index-list').append('<li><a href="' + this.clientUrl + '" class="title">' + this.title +'</a><span class="teaser">' + this.description +'</span><div class="byline">' + this.printDate +'</div></li>');
			});
			setPagination(json);
		}
		
		function getApi(apiUrl) {
			return $.getJSON(apiUrl);
		}		
		
		function getResults() {
			if (filterContentType == 'Practice Guideline') {
				var apiUrl = '//api.' + getDomain('profreg') + 'medscape.com/contentsearchservice/api/v1/search?q=publicationDate:[NOW-6MONTHS%20TO%20NOW]&plr=ref&page=' + (currPage-1) + '&size=' + pageSize + '&contenttype=' + encodeURIComponent(filterContentType) + '&sort=pubdate';
			} else {
				var apiUrl = '//api.' + getDomain('profreg') + 'medscape.com/contentsearchservice/api/v1/search?q=*&plr=ref&page=' + (currPage-1) + '&size=' + pageSize + '&contenttype=' + encodeURIComponent(filterContentType) + '&sort=pubdate';
				if (currSpecialty != '') {
					apiUrl = '//api.' + getDomain('profreg') + 'medscape.com/contentsearchservice/api/v1/search?q=*&plr=ref&page=' + (currPage-1) + '&size=' + pageSize + '&contenttype=' + encodeURIComponent(filterContentType) + '&sort=pubdate&specialty=' + currSpecialty;
				}
			}
			return getApi(apiUrl).done(function(json) {
				renderResult(json);
			});
		}		
		
		function outputPageNum(startIndex, endIndex) {
			for (var x = startIndex; x <= endIndex; x++) {
				$('.index-pagination ul').append('<li><a data-num="' + x + '">' + x + '</a></li>');			
			}
		}
		
		function setPagination(json) {
			$('.index-pagination ul').html('');
			numFound = json.data.response.numFound;
			totalPage = Math.ceil(numFound/pageSize);
			
			if (totalPage <= 1) {
				return;
			}
			
			if (totalPage <= 5 || currPage <= 3) { // Beginning of list
				if (totalPage >= 5) {
					outputPageNum(1, 5);
				}
				else {
					outputPageNum(1, totalPage);
				}   
			}
			else if (totalPage - currPage < 3) { // End of list
				outputPageNum(totalPage - 4, totalPage);
			}
			else { // Middle of list
				outputPageNum(currPage - 2, currPage + 2);
			}
			
			$('.index-pagination ul').append('<li class="page-label">Page ' + currPage + '</li>');
			
			if (currPage > 1) {
				$('.index-pagination ul').prepend('<li class="forward-backward page-last"><a> &nbsp; </a></li>');
			}
			if (currPage < totalPage) {
				$('.index-pagination ul').append('<li class="forward-backward page-next"><a> &nbsp; </a></li>');
			}
			
			$('.index-pagination ul a[data-num="' + currPage + '"]').addClass('selected');
			
			$('.index-pagination ul li:not(.forward-backward) a:not(.selected)').on('click', function() {
				currPage = Number($(this).attr('data-num'));
				getResults();
				$(window).scrollTop(0)
			});
			
			$('.page-next').on('click', function() {				
				currPage = currPage + 1;
				getResults();
				$(window).scrollTop(0);
			});
			
			$('.page-last').on('click', function() {
				currPage = currPage - 1;
				getResults();
				$(window).scrollTop(0);
			});
			
		}

		function closeAllSelect() {
			$('.filter-select').removeClass('filter-item-active');
			$('.filter-items').addClass('filter-hide');
		}	
				
		function bindFilter() {
		
			$('li[data-value="Med Students"],li[data-value="Medscape Today"],li[data-value="Nursing"],li[data-value="Pharmacist"]').remove();
			
			$('.filter-items li').click(function() {
				currSpecialty = encodeURIComponent($(this).attr('data-value'));
				currPage = 1;
				getResults();
				$('.filter-select').html($(this).html());
				$('.same-as-selected').removeClass('same-as-selected');
				$(this).addClass('same-as-selected');
				closeAllSelect();
				if ($(this).attr('data-value') == "") {
					$('.cslt-widg-inst').attr('data-tag','physician10');
					$('.cslt-widg-inst').attr('data-cslt-link-url','//www.medscape.com/consult');
				} else {
					$('.cslt-widg-inst').attr('data-tag',$(this).attr('data-value'));
					$('.cslt-widg-inst').removeAttr('data-cslt-link-url');
				}
				if (typeof csltWidg != 'undefined') {
					csltWidg.init();
				}
				try {
					wmdPageLink(filterTrackPrefix + '_spec');
				}
				catch(e) { console.log(e); }
			});			
			$('.filter-select').click(function(e) {
				e.stopPropagation();
				$('.filter-items').toggleClass('filter-hide');
				$(this).toggleClass('filter-item-active');
				if ($(this).hasClass('filter-item-active')) {
					try {
						wmdPageLink(filterTrackPrefix + '_open');
					}
					catch(e) { console.log(e); }
				} else {
					try {
						wmdPageLink(filterTrackPrefix + '_close');
					}
					catch(e) { console.log(e); }				
				}
			});
			$(document).click(closeAllSelect);	
		}
		
		function chkQueryOnLoad() {
			if (chkQuery('specialty') != null) {
				currSpecialty = chkQuery('specialty');
				$('.filter-select').html(decodeURIComponent(currSpecialty));
			}		
			if (chkQuery('page') != null && !isNaN(Number(chkQuery('page')))) {
				currPage = Number(chkQuery('page'));
			}
		}
		
		function chkFilterExist() {
			if ($('.filter-items li[data-value!=""]').length > 0) {
				bindFilter();
			} else if (currSpecialty == '' && typeof currResult != 'undefined') {
				$(currResult.data.facet_counts.facet_fields.allSpecialties).each(function() {
					$('.filter-items').append('<li data-value="' + this.value + '">' + this.value + '</li>');
				});
				bindFilter();
			} else {
				getApi('//api.' + getDomain('profreg') + 'medscape.com/contentsearchservice/api/v1/search?q=*&plr=ref&page=0&size=' + pageSize + '&contenttype=' + encodeURIComponent(filterContentType)).done(function(json) {
					$(json.data.facet_counts.facet_fields.allSpecialties).each(function() {
						$('.filter-items').append('<li data-value="' + this.value + '">' + this.value + '</li>');
					});
					if (currSpecialty != '') {
						$('.same-as-selected').removeClass('same-as-selected');
						$('.filter-items li[data-value="' + decodeURIComponent(currSpecialty) + '"]').addClass('same-as-selected');
					}
					bindFilter();
				});
			}
		}
		
		function init() {
			chkQueryOnLoad();
			getResults().done(function() {
				chkFilterExist();
			});
		}
		
		init();
	
	}
}

export default _.catch(indexFilter);